import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { cleanHtml } from '../../../../utils/stringHelper';

function ResourceListItem({ resource, handleClickResource }) {
  return (
    <div
      className="w-full flex flex-row justify-between items-end p-5 cursor-pointer hover:bg-slate-100"
      onClick={handleClickResource}>
      <div className="h-full flex flex-row gap-x-5">
        <img
          className="h-32 w-32 object-cover shadow-md block rounded-md"
          src={resource.main_image ? resource.main_image.file : getImage('img-ph.png')}
          alt={resource.main_image ? resource.main_image.label : 'Non renseignée'}
        />

        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col gap-y-0.5">
            <h3 className="text-xl font-bold text-slate-700 ">{resource.title}</h3>
            <p
              dangerouslySetInnerHTML={{ __html: cleanHtml(resource.description) }}
              className="line-clamp-2"
            />
          </div>

          <div className="flex flex-row gap-x-3">
            <Tag tag={getConstant('melismes.common.statusTypes', resource.status)} />
            <Tag tag={getConstant('melismes.resourceTypes', resource.type)} rounded />
            <Tag
              tag={{
                label: resource.program?.title,
                bgColor: 'bg-slate-700',
                icon: 'program'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResourceListItem;
